// import Vue from 'vue'
import Radio from './radio'

export default {
    install: function(Vue) {
        Vue.component('MyRadio', Radio)
    }
}
